const loadScript = (url, timeout, additionalProps = null) => {
  let time = 0
  if (timeout) {
    time = timeout
  }
  setTimeout(() => {
    const script = document.createElement('script')
    script.setAttribute('type', 'text/javascript')
    if (additionalProps
      && Object.keys(additionalProps).length > 0
      && additionalProps.constructor === Object) {
      Object.entries(additionalProps).forEach((item) => {
        script.setAttribute(item[0], item[1])
      })
    }
    script.setAttribute('src', url)
    document.body.appendChild(script)
  }, time)
}

export default loadScript
